<template>
  <div>
    <!-- Counter Widgets -->
    <a-row :gutter="10">
      <a-col :span="24" :md="8" :lg="12" :xl="6" class="mb-24">
        <WidgetCounter :title="cardTotalAlumniData.title" :value="cardTotalAlumniData.value"
          :icon="cardTotalAlumniData.icon" :isLoaded="isTotalAlumniLoaded">
        </WidgetCounter>

      </a-col>
      <a-col :span="24" :md="8" :lg="12" :xl="6" class="mb-24">
        <WidgetCounter :title="cardTotalAlumniMember.title" :value="cardTotalAlumniMember.value"
          :icon="cardTotalAlumniMember.icon" :isLoaded="isTotalAlumniMemberLoaded"></WidgetCounter>
      </a-col>
      <!-- <a-col :span="24" :md="8" :lg="12" :xl="6" class="mb-24">
        <WidgetCounter :title="cardTotalAlumniAchievement.title" :value="cardTotalAlumniAchievement.value"
          :icon="cardTotalAlumniAchievement.icon" :isLoaded="isTotalAlumniAwardLoaded"></WidgetCounter>
      </a-col> -->
    </a-row>
    <!-- / Counter Widgets -->
    <a-row>
      <a-col :sm="23" :md="23" :lg="23" class="mb-24">
        <a-card :bordered="false" class="dashboard-bar-chart">
          <a-row>
            <a-col :xs="24" :sm="24" :md="24">
              <div>
                <h6>Number of graduates per year</h6>
                <!-- <p>Description...</p> -->
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" style="text-align: right">
            </a-col>
          </a-row>
          <span v-if="isChartGraduetedLoaded">
            <CardApexLineCharts 
              :barChartData="dataChartGradueted"/>
          </span>
          <span v-else>
            <div style="height:280">
              <a-skeleton size="small" rows="5" />
            </div>
          </span>
        </a-card>
      </a-col>
    </a-row>

    <a-row>
      <a-col :sm="23" :md="23" :lg="12" class="mb-24">
        <a-card :bordered="false" class="dashboard-bar-chart">
          <a-row>
            <a-col :xs="24" :sm="24" :md="24">
              <div>
                <h6>Comparison of Employment and Further Study Status</h6>
                <!-- <p>Description...</p> -->
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" style="text-align: right">
            </a-col>
          </a-row>
          <span v-if="isChartEngegementLoaded">
            <CardApexColumnCharts 
              :barChartData="dataChartGradueted"/>
          </span>
          <span v-else>
            <div style="height:450">
              <a-skeleton size="small" rows="5" />
            </div>
          </span>
        </a-card>
      </a-col>
      <a-col :sm="24" :md="24" :lg="11" class="mb-24  ml-10">
        <a-card :bordered="false" class="dashboard-bar-chart">
          <a-row>
            <a-col :xs="24" :sm="24" :md="24">
              <div>
                <h6>Employment rate by type of job</h6>
                <!-- <p>Description...</p> -->
              </div>
            </a-col>
            <a-col :xs="24" :sm="24" :md="12" style="text-align: right">
            </a-col>
          </a-row>
          <span v-if="isChartEngegementLoaded">
            <CardApexSingleColumnCharts 
              :barChartData="dataChartGradueted"/>
          </span>
          <span v-else>
            <div style="height:280">
              <a-skeleton size="small" rows="5" />
            </div>
          </span>
        </a-card>
      </a-col>
    </a-row>

    <!-- / Charts -->
  </div>
</template>

<script>
// Bar chart for "Active Users" card.
import CardApexLineCharts from "./CardApexLineCharts";

import CardApexColumnCharts from "./CardApexColumnCharts";

import CardApexSingleColumnCharts from "./CardApexSingleColumnCharts";


// Line chart for "Sales Overview" card.
import CardLineChart from "./CardLineChart";

// Counter Widgets
import WidgetCounter from "./WidgetCounter";

import VueApexCharts from 'vue-apexcharts'


const dataGradueted = {
  labels: [],//["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021"],
  datasets: [],
};

const dataEngagement = {
  labels: [],
  datasets: [],
};

const cardTotalAlumniData = {
  title: "Total MUIC Alumni",
  value: 0,
  prefix: "",
  suffix: "",
  icon: `
        <svg data-v-f65eec2c="" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 640 512"
                    class="fill-primary ">
                    <path data-v-f65eec2c=""
                        d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z">
                    </path>
                </svg>
`,
};

const cardTotalAlumniMember = {
  title: "Total MUICAA members",
  value: 0,
  suffix: "",
  icon: `
                        <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
                            <path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
                            <path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
                            <path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
                        </svg>`,
};

const cardTotalAlumniAchievement = {
  title: "Employment rate by type of job",
  value: 0,
  prefix: "",
  status: "danger",
  suffix: "",
  icon: `
                        <svg data-v-f65eec2c="" xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                            viewBox="0 0 384 512" class="fill-primary   ">
                            <path data-v-f65eec2c=""
                                d="M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z">
                            </path>
                        </svg>
                        `,
};

const cardTotalAlumniEngagement = {
  title: "Total Alumni Engagement",
  value: 0,
  prefix: "",
  suffix: "",
  icon: `
                        <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z" fill="#111827"/>
                        </svg>`,
};

export default {
  components: {
    CardApexLineCharts,
    CardApexColumnCharts,
    CardLineChart,
    WidgetCounter,
    CardApexSingleColumnCharts,
    VueApexCharts
  },
  mounted() {
    this.getTotalAlumni();
    this.getTotalAlumniMember();
    this.getTotalAlumniAward();
    this.getTotalAlumniGradued();
  },
  methods: {
    //counter
    async getTotalAlumni() {
      try {
        const res = await this.$http.get(
          `/student_affair/alumni-profile/summary_all/`
        );
        if (res.status === 200) {
          this.cardTotalAlumniData.value = res.data.amount;
          this.isTotalAlumniLoaded = true
        } else {
          throw { res };
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getTotalAlumniMember() {
      try {
        const res = await this.$http.get(
          `/student_affair/alumni-profile/summary_muicaa_member/?membership_id__isnull=false`
        );
        if (res.status === 200) {
          //console.log(res.data);
          this.cardTotalAlumniMember.value = res.data.amount;
          this.isTotalAlumniMemberLoaded = true
        } else {
          throw { res };
        }
      } catch (error) {
        //console.log(error);
        this.isTotalAlumniMemberLoaded = true
      }
    },
    async getTotalAlumniAward() {
      try {
        const res = await this.$http.get(
          `/student_affair/alumni-profile/summary_alumni_award/`
        );
        if (res.status === 200) {
          // //console.log(res.data);
          this.cardTotalAlumniAchievement.value = res.data.amount;
          this.isTotalAlumniAwardLoaded = true
        } else {
          throw { res };
        }
      } catch (error) {
        this.isTotalAlumniAwardLoaded = true

      }
    },
    //bar chart
    async getTotalAlumniGradued() {
      this.isChartGraduetedLoaded = false
      try {
        const res = await this.$http.get(
          `/student_affair/alumni-profile/summary_graduate_year/`
        );
        if (res.status === 200) {
          //console.log(res.data);
          this.dataChartGradueted.labels = res.data.map(data => data.graduate_year)
          this.dataChartGradueted.datasets = res.data.map(data => data.amount)
          this.isChartGraduetedLoaded = true
          //console.log(this.dataChartGradueted);
        } else {
          throw { res };
        }
      } catch (error) {
        this.isChartGraduetedLoaded = true
        this.$emit("msgNotification", {
          title: `Error ${error.response.status}`,
          msg: "Connect API : /portal/announcement/ problem !!!",
          backgroundColor: "#ff1919",
          color: "#ffffff",
        });
      }
    },
  },
  data() {
    return {
      //is card loaded
      isTotalAlumniLoaded: false,
      isTotalAlumniMemberLoaded: false,
      isTotalAlumniAwardLoaded: false,
      //is chart loadded
      isChartGraduetedLoaded: false,
      isChartEngegementLoaded: true,
      //card total data
      cardTotalAlumniData,
      cardTotalAlumniMember,
      cardTotalAlumniAchievement,
      cardTotalAlumniEngagement,
      //chart data
      dataChartGradueted: Object.assign({}, dataGradueted),
      dataChartEngagement: Object.assign({}, dataEngagement),
      series: [
        {
          name: "Alumni",
          data: [28, 29, 33, 36, 32, 32, 33]
        }
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: false
          }
        },
        colors: ['#77B6EA', '#545454'],
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: 'Average High & Low Temperature',
          align: 'left'
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        markers: {
          size: 1
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
          title: {
            text: 'Month'
          }
        },
        yaxis: {
          title: {
            text: 'Temperature'
          },
          min: 5,
          max: 40
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      },
    };
  },
};
</script>

<style lang="scss"></style>